import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { Avatar } from "@mui/material";
const apiUrl = process.env.PORTAL_URL || "http://localhost:7004";
export const Buttons = ({ botoes }) => {
    return (_jsx(Box, Object.assign({ display: "flex", flexDirection: "row", justifyContent: "center", flexWrap: "wrap", gap: 6 }, { children: botoes.map((botao) => {
            return (
            // <IconButton aria-label="delete" disabled color="primary">
            //   <CardMedia
            //     sx={{ width: "100%", height: 100 }}
            //     image={`${apiUrl}/api/doacao-sangue/assets/${botao.icon}`}
            //     title="green iguana"
            //   />
            // </IconButton>
            _jsxs(Box, Object.assign({ display: "flex", flexDirection: "column", alignItems: "center", gap: 1, sx: { cursor: "pointer" } }, { children: [_jsx(Avatar, { alt: botao.label, src: `${apiUrl}/api/doacao-sangue/assets/${botao.icon}`, sx: { width: 80, height: 80 }, onClick: botao.onClick }), _jsx(Typography, Object.assign({ variant: "caption" }, { children: botao.label }))] }))
            // <Card
            //   sx={{ maxWidth: 345, minWidth: 200 }}
            //   key={index}
            //   onClick={botao.onClick}
            // >
            //   <CardMedia
            //     sx={{ height: 140 }}
            //     image={`${apiUrl}/api/doacao-sangue/assets/${botao.icon}`}
            //     title="green iguana"
            //   />
            //   <CardContent>
            //     <Typography gutterBottom variant="body2" component="div">
            //       {botao.label}
            //     </Typography>
            //     <Typography variant="body2" sx={{ color: "text.secondary" }}>
            //       {botao.subtitle}
            //     </Typography>
            //   </CardContent>
            //   {/*<CardActions>*/}
            //   {/*    <Button size="small">Share</Button>*/}
            //   {/*    <Button size="small">Learn More</Button>*/}
            //   {/*</CardActions>*/}
            // </Card>
            );
        }) })));
};
